module.exports = __webpack_public_path__ + "static/media/Blade_SidePinArm.e520981d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/Blade_SidePinArm.jpg
// module id = 295
// module chunks = 0